import { render, staticRenderFns } from "./category-contest.vue?vue&type=template&id=cdb3cc68"
import script from "./category-contest.vue?vue&type=script&lang=js"
export * from "./category-contest.vue?vue&type=script&lang=js"
import style0 from "./category-contest.vue?vue&type=style&index=0&id=cdb3cc68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports